const text_to_handwriting = {
    title: "Text to Handwriting",
    githubUrl: "https://github.com/AellyOfficial/Aelly.ai",
    demoUrl: "https://aellyofficial.github.io/Aelly.ai",
    shortDescription:
        "Convert your typed text into beautiful, handwritten-style images with ease",
    longDescription:
        "Tired of typing—but still need that handwritten look? Text-to-Handwriting is a web-based tool that transforms plain text into images that mimic real handwriting. Originally created as a clever workaround for handwritten assignments, it’s now archived but remains highly useful and fun to explore.",
    tools: ["html2canvas", "JavaScript", "CSS", "HTML", "jsPDF"],
    image: "/assets/images/projects/devProjects/TextoHandwriting.jpg",
    webpImage: "/assets/images/projects/devProjects/TextoHandwriting.webp",
    key: 0,
};

const tarot = {
    title: "Tarot",
    githubUrl: "https://github.com/itzKARAN/Tarot-Reader.git",
    demoUrl: "https://awesome-albattani-455531.netlify.app",
    shortDescription: "Using a public tarot API in combination with a printable tarot deck found online, I created a web",
    longDescription:
        "Using a public tarot API in combination with a printable tarot deck found online, I created a web app that provides users with daily tarot readings as well as an image library where users can learn the meanings behind all 78 cards.",
    tools: ["Vue", "Redux", "JavaScript", "CSS", "HTML"],
    image: "/assets/images/projects/devProjects/tarot.jpg",
    webpImage: "/assets/images/projects/devProjects/tarot.webp",
    key: 1,
};

const student_dashboard = {
    title: "Student Dashboard",
    githubUrl: "https://github.com/kkara9009/Student_Dashboard",
    demoUrl: "https://eloquent-darwin-440c3c.netlify.app",
    shortDescription: "A dashboard that displays student satisfaction numbers",
    longDescription:
        "Built a dashboard that displays how satisfied students are with the assignments they received from their university/ academy, using charts and tables to visualize the data.",
    tools: ["React", "Redux", "JavaScript", "CSS", "HTML", "Chart.js"],
    image: "/assets/images/projects/devProjects/dashboard.jpg",
    webpImage: "/assets/images/projects/devProjects/dashboard.webp",
    key: 2,
};

const aellyx = {
    title: "AlleyX",
    githubUrl: "https://github.com/anonAELLY/AellyX",
    demoUrl: "",
    shortDescription: "AellyX is a powerful DDoS toolkit for penetration tests, including attacks for several protocols written in",
    longDescription:
        "AellyX is a powerful DDoS toolkit for penetration tests, including attacks for several protocols written in python(3.8).Takedown WiFi access points, devices in your network, servers, services, and Bluetooth devices with ease. Aelly(abbreviation) is desinged to help you to test, understand, and learn from stress-testing attacks.Aelly can deal with strong servers and can be optimized for non typical targets.",
    tools: ["Python"],
    image: "/assets/images/projects/devProjects/AlleyX.jpg",
    webpImage: "/assets/images/projects/devProjects/AlleyX.webp",
    key: 3,
};

const portfolio = {
    title: "Portfolio",
    githubUrl: "https://github.com/k4ran909/Portfolio",
    demoUrl: "http://k4ran.me/K4RAN",
    shortDescription: "This is the website you are viewing right now. Using React built a portfolio website that allows users to toggle",
    longDescription:
        "This is the website you are viewing right now. Using React built a portfolio website that allows users to toggle between designer and developer mode and view past and current projects. Designed 2 interactive homepages and 2 projectcards that react to the user's cursor movements.",
    tools: ["React", "Redux", "CSS", "JavaScript", "HTML", "Parallax.js"],
    image: "/assets/images/projects/devProjects/portfolio.png",
    webpImage: "/assets/images/projects/devProjects/portfolio.webp",
    key: 4,
};


// reverse array to ensure last projects added to array appear on top
export const featured_projects = [
    text_to_handwriting,
    tarot,
    student_dashboard,
    aellyx,
    portfolio,
].reverse();